import { render, staticRenderFns } from "./ColumnDeliverStatus.vue?vue&type=template&id=539c2e98&scoped=true"
import script from "./ColumnDeliverStatus.vue?vue&type=script&lang=js"
export * from "./ColumnDeliverStatus.vue?vue&type=script&lang=js"
import style0 from "./ColumnDeliverStatus.vue?vue&type=style&index=0&id=539c2e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539c2e98",
  null
  
)

export default component.exports